/* eslint-disable import/no-default-export */
import flatpickr from 'flatpickr'
import moment from 'moment'
import useJwt from '@/auth/jwt/useJwt'
import messages from '@intlify/unplugin-vue-i18n/messages'
import { english } from 'flatpickr/dist/l10n/default.js'
import { Spanish } from 'flatpickr/dist/l10n/es.js'

import 'moment/dist/locale/es'

import Vue from 'vue'
import { localize } from 'vee-validate'
import DatePicker from 'vue2-datepicker'

import 'vue2-datepicker/locale/en'
import 'vue2-datepicker/locale/es'

import VueI18n from 'vue-i18n'
import { castToVueI18n, createI18n } from 'vue-i18n-bridge'

Vue.use(VueI18n, { bridge: true })

function loadLocalTime(locale) {
    switch (locale) {
        case 'es':
            return Spanish
        case 'en':
            return english
        default:
            return english
    }
}

export function configureLanguage(locale) {
    flatpickr.localize(loadLocalTime(locale))
    DatePicker.locale(locale)
    localize(locale)
    moment.locale(locale)
}

configureLanguage(useJwt.getLanguage())

const i18n = castToVueI18n(
    createI18n(
        {
            legacy: false,
            silentTranslationWarn: true,
            locale: useJwt.getLanguage(),
            messages,
        },
        VueI18n
    )
)

export const _messages = messages

Vue.use(i18n)

export default i18n

if (import.meta.hot) {
    import.meta.hot.accept(module => {
        Object.entries(module._messages).forEach(([locale, messages]) => {
            i18n.mergeLocaleMessage(locale, messages)
        })
        if (!i18n.sync) {
            console.warn(
                '[i18n hmr] No se pudo sincronizar correctamente los cambios de messages, recargue de forma manual'
            )
        }
    })
}
